import { render, staticRenderFns } from "./AsideA.vue?vue&type=template&id=3497cea6"
import script from "./AsideA.vue?vue&type=script&lang=js"
export * from "./AsideA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports